import { isPropertyActiveState } from "@/store/propertyCore/propertyApi";

/**
 * Whether a DealLens row is actionable (deal + hydrated propertyDetails when present).
 * Unhydrated deals without propertyDetails stay available so enrichment lag does not false-positive.
 *
 * @param {object | null | undefined} deal
 * @returns {boolean}
 */
export function isDealLensRowAvailable(deal) {
  if (deal?.active === false) return false;
  if (deal?.propertyDetails) return isPropertyActiveState(deal.propertyDetails);
  return true;
}
